const HIDE_TRANSITION_IN_MILLISECONDS = 500;
const SHOW_TRANSITION_IN_MILLISECONDS = 800;

interface ITimelineItem {
  id: string;
  visibleCount: number;
  stepCount: number;
  active: boolean;
}

export function initTimeline() {

  const timelines = Array.from(document.getElementsByClassName('js-timeline-enabled'));

  if (timelines.length > 0) {

    timelines.forEach(timeline => {

      const collapsed = $(timeline).data('collapsed') as boolean;
      timeline as HTMLElement;

      const myItem: ITimelineItem = {
        id: $(timeline).data('timeline-id'),
        active: collapsed,
        visibleCount: $(timeline).data('visible'),
        stepCount: $(timeline).data('step')
      };

      const myButton = timeline.getElementsByClassName('show-more-button')[0] as HTMLElement;
      let myItems = Array.from(timeline.getElementsByClassName('timeline-item'));

      if (myItem.active && myItems.length > myItem.visibleCount) {

        myItems.forEach((item, index) => {
          if (index > (myItem.visibleCount - 1)) {
            $(item).hide();
          }
        });

        if (myButton != null) {
          myButton.addEventListener('click', (event) => {
            showMore(event);
          });
        }

      } else if (myButton != null) {

        $(myButton).hide(HIDE_TRANSITION_IN_MILLISECONDS);

      }
    });

  }

  function showMore(event: Event) {

    event.preventDefault();

    const button = event.target as HTMLElement;

    const timeline = $(button).closest('.js-timeline-enabled');
    let items = $(timeline).find('.timeline-item:hidden');

    if (items.length > 0) {

      let stepSize = timeline.data('step');
      if (stepSize === null || stepSize === undefined) {
        stepSize = 5;
      }

      $.each(items, function (index, item) {
        if (index < stepSize) {
          $(item).show(SHOW_TRANSITION_IN_MILLISECONDS);
        }
      });

      if (items.length <= stepSize) {
        $(button).hide(HIDE_TRANSITION_IN_MILLISECONDS);
      }

    } else if (button != null) {

      $(button).hide(HIDE_TRANSITION_IN_MILLISECONDS);

    }

  }

}
